/**
 * @param {string} markup принимает весь код верстки плеера
 * @returns {string}
 */
export function getSrcFromMarkup(markup) {
  const resultSrc = RegExp(/src=['|"]([^"']+)['|"]/).exec(markup);

  return resultSrc ? resultSrc[1] : '';
}

export function getIsShortsFromMarkup(markup, providerName) {
  if (providerName !== 'youtube') return false;

  const isShorts = RegExp(/data-shorts=['|"]([^"']+)['|"]/).exec(markup);

  return !isShorts ? false : !!isShorts[1];
}

/**
 * @param {string} providerName название видео платформы
 * @param {string} code код видео из админки
 * @param {object} parsedCode параметры из кода видео
 * @param {string} parsedCode.pathname код видео
 * @param {object} parsedCode.query параметры в коде видео
 * @return {string} возвращает id видео
 */
export function getVideoId(providerName, code, parsedCode) {
  if (providerName === 'vk' || providerName === 'other') {
    return parsedCode?.href || code;
  }

  if (providerName === 'videoplatform') {
    const videoId = /data-id=['|"]([^"']+)['|"]/.exec(code);
    return videoId ? videoId[1] : '';
  }

  if (providerName === 'youtube') {
    if (!parsedCode) return code;

    const { pathname, query } = parsedCode;
    if (query.v) return query.v;

    return typeof pathname === 'string' ? pathname.split('/').pop() : '';
  }

  return '';
}
